import axios from "axios";
import { getCookie } from "../components/getcookie";
const apiUrl = process.env.REACT_APP_API_URL;

// Axios instance with default configuration
const axiosInstance = axios.create({
    baseURL: apiUrl,
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
      "Accept": "application/json",
    },
  });


  // Add an Authorization token if available (for authenticated requests)
axiosInstance.interceptors.request.use(
    (config) => {
      const token = getCookie("mawalog");  // Replace with your actual method of retrieving the token
      if (token) {
        config.headers["Authorization"] = token;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );


  const handleError = (error) => {
    // You can log or process the error further here if needed
    console.error("API Error: ", error); // Log the error to the console (or you can handle it differently)
    // Optionally, you can return a default error message or object
    return { error: true, message: "An error occurred while making the request." };
  };
  
  // Helper function to handle GET requests
const get = async (endpoint, params = {}) => {
    try {
      const response = await axiosInstance.get(endpoint, { params });
      return response; // Return the full response object
    } catch (error) {
      return handleError(error); // Return the error response if it fails
    }
  };

  export { get };

